<template>
  <div>  
    <router-view />    
    <div class="q-pa-md" :v-if="price">
      <div class="q-pa-md q-gutter-sm">
        <q-breadcrumbs>
          <q-breadcrumbs-el icon="home" to="/home" />
          <q-breadcrumbs-el
            label="Price Tracker"
            icon="widgets"
            :to="{path:'/priceoptimization/home/' + this.$org_id.label}"
          />
        </q-breadcrumbs>
      </div>
      <div class="introWindow" style="margin-top:10rem;">
        <router-link
              to="/pricewatch/product"
              style="text-decoration: none; color: inherit;"
            >
              <div class="card-i">
                <img class="cardimg" src="../../assets/revenue.png" />

                <!-- <q-card-section>Enter Price Tracker</q-card-section> -->
              </div>
            </router-link>
        <h6 class="headi">Click on the above icon to enter Price Tracker</h6>
    
          <!-- <h5 style="color: dodgerblue;">uniQin's AI & ML backend analyses the data to</h5>
            <p style="font-size:17px;"><img class="icon" src="../../assets/check.png" />  Make a profit boom with profit maximisation</p>
            <p style="font-size:17px;"><img class="icon" src="../../assets/check.png" />  Find the perfect price for your products</p>
            <p style="font-size:17px;"><img class="icon" src="../../assets/check.png" />  Maximise revenue with optimal discounts</p>
            <p style="font-size:17px;"><img class="icon" src="../../assets/check.png" />  Boost revenue with revenue maximisation</p>
            <p style="font-size:17px;"><img class="icon" src="../../assets/check.png" />  Sell off dead stocks with volume optimisation</p>
          <h5 style="color:dodgerblue;">We will suggest the price for the next two weeks which helps you</h5>
            <p style="font-size:17px;"><img class="icon" src="../../assets/check.png" />  Find the fair price for your product, given the elasticity, market trend, seasonality and historic patterns</p>
            <p style="font-size:17px;"><img class="icon" src="../../assets/check.png" />  Achieve maximium profit, revenue or volume</p> -->

        

        <!--<div class="row">
          <div class="column">
            <router-link
              to="/priceoptimization/home"
              style="text-decoration: none; color: inherit"
            >
              <div class="card-i">
                <img class="cardimg" src="../../assets/profit.png" />

                <q-card-section> Profit </q-card-section>
              </div>
            </router-link>
          </div> -->
        <!-- <div class="row">
          <div class="column">
            
          </div>
          </div> -->
     <!--     <div class="column">
            <router-link
              to="/pricewatch/profit"
              style="text-decoration: none; color: inherit"
            >
              <div class="card-i">
                <img class="cardimg" src="../../assets/revenue.png" />

                <q-card-section>Profit</q-card-section>
              </div>
            </router-link>
          </div>
          <div class="column">
            <router-link
              to="/pricewatch/marketshare"
              style="text-decoration: none; color: inherit"
            >
              <div class="card-i">
                <img class="cardimg" src="../../assets/revenue.png" />

                <q-card-section>Market Share</q-card-section>
              </div>
            </router-link>
          </div>
        </div>
        -->
          <!-- <div class="column">
            <router-link
              to="/priceoptimization/home"
              style="text-decoration: none; color: inherit"
            >
              <div class="card-i">
                <img class="cardimg" src="../../assets/volume.png" />
                <q-card-section> Volume </q-card-section>
              </div>
            </router-link>
          </div> -->
        </div>
      </div>
    </div>

</template>

<script>
export default {
  data() {
    return {
      price: window.location.pathname == "/pricewatch",
    };
  },
     mounted(){
      this.$q.loading.show({
       message: "Authenticating please wait..",
     });

      if(this.$cookies.isKey("login_authentication"))
     {
       let encryptedText = this.$cookies.get("login_authentication");

       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);

       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$q.loading.hide();
        this.isAuthenticated = true;

       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;

       }
       

     }
     else if(this.$cookies.isKey("login_authentication1"))
     {
       let encryptedText = this.$cookies.get("login_authentication1");

       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);

       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
        this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;

       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;

       }
       

     }
     else if(this.$cookies.isKey("login_authentication2"))
     {
       let encryptedText = this.$cookies.get("login_authentication2");

       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);

       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$q.loading.hide();
        this.isAuthenticated = true;

       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;

       }
       

     }
     else{

       this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;

     }

    },

  
};
</script>

<style  scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");
.q-card__section--vert {
  padding: 0;
}
/*li span {
      position: relative;
      left: +100px;
}*/
.headi{
    font-size:40px;
    text-align:center;
    color:rgb(33, 103, 233);
    font-family: "Poppins", sans-serif !important;
    font-weight:bold;
}
.q-scrollarea {
    position: relative;
    align-items: center;

    margin: auto;
}

.q-scrollarea {
    position: relative;
    margin: auto;
}

/* Float four columns side by side */
.column {
  float: left;
  height:8rem;
  width:100%;
  max-height: 10rem;
  max-width: 10rem;
  padding: 0 10px;
}

/* Remove extra left and right margins, due to padding */
.row {
  margin-top: 3rem;
  align-items: center;
  justify-content: center;
}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}

/* Responsive columns */
@media screen and (max-width: 600px) {
  .column {
    width: 100%;
    display: block;
    margin-bottom: 20px;
  }
}

/* Style the counter cards */
.card-i {
  box-shadow: 0px 5px 15px -2px rgb(26 108 220);
  border-radius: 10px;
  padding: 16px;
  text-align: center;
  background-color: #f1f1f1;
  width: auto;
  max-height: 8rem;
  max-width: 8rem;
  margin: auto;
  transition:all 500ms ease;
}
.card-i:hover{
  background-color: #b8b8b8;
}

.scroll {
  margin: auto;
  width: 80%;
  background: #f9f6f7;
  border-radius: 10px;
  box-shadow: 0px 5px 15px -2px rgb(26 108 220);
}

.cardimg {
  text-align: center;
  margin: auto;
  height: 3rem;
  width: 3rem;
  min-height: 50px;
  min-width: 50px;
  margin-top: 10px;
}

.icon {
  text-align: center;
  margin: auto;
  height: 1rem;
  width: 1rem;
  min-height: 15px;
  min-width: 15px;
  /*margin-top: 10px;*/
}

.introWindow {
  text-align: center;
  background: transparent;
}
/* .row {
  max-width: 50%;
  margin-top: 3rem;
  margin-bottom: 2rem;
  margin-left: auto;
  margin-right: auto;
} */
.q-page-container {
  height: 100vh;
  overflow: hidden;
}

.flex-container {
  padding-top: 1rem;
  padding-bottom: 1rem;
  display: flex;
  flex-wrap: wrap;
  max-width: 60%;
  margin: 1rem auto;
}

@media (max-width: 400px) {
  .flex-container {
    flex-direction: column;
  }
}
</style>



<!-- <template>
  <q-layout view="hHh Lpr lff">
    <!-- <h4>Price Tracker</h4> -->
<!--
    <div class="q-pa-md q-gutter-sm">
        <q-breadcrumbs>
          <q-breadcrumbs-el icon="home" to="/home" />
          <q-breadcrumbs-el
            label="Price Tracker"
            icon="widgets"
            to="/pricewatch/products"
          />
        </q-breadcrumbs>
    </div>

  
    <q-tabs align="left">
      <q-route-tab to="/pricewatch/products" label="Products" />      -->
  <!--    <q-route-tab to="/pricewatch/competitors" label="Competitors" />
      <q-route-tab to="/pricewatch/pricecomparison" label="Price Comparison" />
      
      
    </q-tabs>

    <div>
     
    </div>

    <q-page-container class="q-pa-md">
      <router-view />
    </q-page-container>

  </q-layout>
  
</template>

<script>
export default {
  created(){
  },
  data() {
    return {
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      products: []
    };
  },
  
}
</script>

<style lang="stylus" scoped>

</style>


-->
